export default __webpack_public_path__ + "static/media/granville25.d76aff76.jpg";